import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { PROGRAMMES } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={PROGRAMMES} id={id} />;
}

export const Route = createFileRoute("/_app/structure/programmes/$id")({
  component: Edit,
});
